import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { AuditLogComponent } from './components/audit-log/audit-log.component';
import { AuditItemsComponent } from './components/audit-items/audit-items.component';
import { SharedModule } from '../../shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import { SettingsComponent } from './components/settings/settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [    
    AdminLayoutComponent,
    UserManagementComponent,
    AuditLogComponent,
    AuditItemsComponent,
    SettingsComponent    
  ],
  imports: [
    CommonModule, 
    SharedModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,   
  ],
  exports: [
    AdminLayoutComponent,
  ],
})
export class AdminModule { }
